import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import { UpdateDateSuccess } from '../actions/date.actions';
import { ChangeControlGroup, ChangeExcluded } from '../actions/download-recipients.actions';
import { CloseDownloadCRDialog, OpenDownloadCRDialog } from '../actions/search.actions';
import { DownloadRecipientsState } from '../models/campaign-management.model';

export const initialState: DownloadRecipientsState = {
  id: 0,
  title: '',
  description: '',
  date: '',
  controlGroup: false,
  excluded: false,
};

export const DownloadRecipientsReducer = createReducer(
  initialState,
  on(OpenDownloadCRDialog, (state, { row }) => ({
    ...state,
    id: row.campaignExecutionId,
    title: row.campaignExecutionTitle,
    description: row.campaignExecutionDescription,
    date: row.campaignExecutionDate,
  })),
  on(ChangeControlGroup, (state) => ({
    ...state,
    controlGroup: !state.controlGroup,
  })),
  on(ChangeExcluded, (state) => ({
    ...state,
    excluded: !state.excluded,
  })),
  on(ActiveComponentChanged, CloseDownloadCRDialog, UpdateDateSuccess, () => initialState),
);
